import { useEffect } from 'react'
import { getPrivilegeElement, getPrivilegePartys, getPrivilegePartyMembers } from '../../../services/sPrivilege/privilege.service';

const useGetPrivileges = (elementId, element, setElement, partys, setPartys, partymembers, setPartymembers) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceElementResponse = await getPrivilegeElement(elementId);
                const responseElement = serviceElementResponse.data;
                
                
                if (responseElement.succeeded) {
                    

                    let servicePartysResponse = await getPrivilegePartys(elementId);
                    const responsePartys = servicePartysResponse.data;

                    if (responsePartys.succeeded) {
                        const aux = [];

                        responsePartys.data.forEach(party => {
                            const { id, elementId, elementPartyNemo, elementPartyCode, name, manager, counterParty, number } = party;
                            aux.push({ id, elementId, elementPartyNemo, elementPartyCode, name, manager, counterParty, number });                        
                        });

                        setPartys(aux);
                    }
                   
                    let servicePartyMembersResponse = await getPrivilegePartyMembers(elementId);
                    const responsePartyMembers = servicePartyMembersResponse.data;

                    if (responsePartyMembers.succeeded) {
                        const aux = [];

                        responsePartyMembers.data.forEach(partyMember => {
                            const { id, elementPartyId, privilegeRoleId, username, userAuthProfileId, deactivate, fullname, partyName, roleName } = partyMember;
                            aux.push({ id, elementPartyId, privilegeRoleId, username, userAuthProfileId, deactivate, fullname, partyName, roleName });                        
                        });

                        setPartymembers(aux);
                    }

                    setElement(responseElement.data[0]);
                }
                               
            }
            catch (error) {
                setElement(null);
                console.log(error)
            }
        }
        
        if (!element) {
            getData()
        }
    }, [elementId]);
}


export {
    useGetPrivileges    
}